import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '@/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { Sparkles, TrendingUp, Target } from 'lucide-react';

const UNI_GOLD = '#d4a843';
const UNI_BORDER = 'rgba(255,255,255,1)';
const UNI_CARD = 'rgba(255,255,255,0.04)';

const PerformanceInsight: React.FC = () => {
  const { userProfile } = useAuth();
  const { t } = useTranslation();

  const profile = userProfile?.global_academic_profile as any;
  if (!profile || !profile.summary) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      style={{
        background: `linear-gradient(145deg, ${UNI_CARD}, rgba(212,168,67,0.08))`,
        border: `1px solid ${UNI_BORDER}`,
        borderRadius: 24,
        padding: '32px',
        marginBottom: '40px',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <div style={{ position: 'absolute', top: -20, right: -20, opacity: 0.05 }}>
        <Sparkles size={160} color={UNI_GOLD} />
      </div>

      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
          <div style={{ background: 'rgba(212,168,67,0.15)', padding: 8, borderRadius: 10 }}>
            <TrendingUp size={20} color={UNI_GOLD} />
          </div>
          <span style={{ fontSize: 13, fontWeight: 700, color: UNI_GOLD, letterSpacing: '1px' }}>
            {t('university.dashboard.aiInsight', 'AI TUTOR INSIGHT')}
          </span>
        </div>

        <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12, color: '#fff', letterSpacing: '-0.5px' }}>
          {profile.title || t('university.dashboard.performanceSummary', 'Academic Standing Summary')}
        </h2>
        
        <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6, maxWidth: '800px', marginBottom: 24 }}>
          {profile.summary}
        </p>

        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {profile.strengths?.slice(0, 3).map((s: string, i: number) => (
            <div key={i} style={{ 
              background: 'rgba(74,222,128,0.08)', 
              border: '1px solid rgba(74,222,128,0.2)', 
              borderRadius: 12, padding: '8px 16px', 
              fontSize: 13, color: '#4ade80', fontWeight: 600,
              display: 'flex', alignItems: 'center', gap: 8
            }}>
              <Target size={14} /> {s}
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default PerformanceInsight;
